module.exports = __webpack_public_path__ + "static/media/ic_check_green.44362d1d.svg";